module.exports = require('./helpers/bundle-url').getBundleURL('9HgYJ') + "logo.7718c6df.svg";